
import React, { Component } from "react";
import { Fields, reduxForm , formValueSelector} from "redux-form";
import { connect } from "react-redux";

import SelectSize from "./SelectSize";

import SeparatingLine from "../../../components/SeparatingLine";
import FormHeader from "../../../components/FormHeader";
import ThemeButton from "../../../components/ThemeButton";
import FormWrapper from "../../FormWrapper";
import validate from "./../validate";
import { getDoorModels, updatePreviousSelection } from '../../../actions';


class SizeForm extends Component {
    componentDidMount(){
        this.props.getDoorModels(this.props.DoorTypeId);
    }

    onSubmit = (values) => {
        this.props.updatePreviousSelection({
            DoorSizeWidth: values.DoorSize.Width,
            DoorSizeUnit: values.DoorSize.Unit
        });
        this.props.onSubmit();
    }

    render(){
        const { loading, MinWidth, MaxWidth, previousPage } = this.props;
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)} className="SizeForm">
                <FormHeader title={(loading? "Loading" :"Opening Size")} subtitle={(loading ? 'LOADING' : `Our doors are suitable between ${MinWidth}mm and ${MaxWidth}mm`)}/>
                <SeparatingLine />
                <FormWrapper>
                    <Fields
                        names={["DoorSize.Width", "DoorSize.Unit"]}
                        range={{ MinWidth, MaxWidth }}
                        component={SelectSize}
                        loading={loading}
                    />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let modelMinWidths = state.Door.Models.map(model => model.minWidth);
    let modelMaxWidths = state.Door.Models.map(model => model.maxWidth);

    return {
        DoorTypeId: valueSelector(state, "DoorTypeId") || 12,
        MinWidth: Math.min(...modelMinWidths),
        MaxWidth: Math.max(...modelMaxWidths),
        loading: modelMinWidths.length === 0 || modelMaxWidths.length === 0,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, {getDoorModels, updatePreviousSelection})(
    reduxForm({
    form: "DoorWizard",
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate,
    initialValues: {
        DoorSize: {
            Unit: "mm",
            Width: 0,
        }
    }
})(SizeForm));


// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/SizeForm.js